import * as z from "zod/v4";

export const generateCopilotResponse = {
  name: "generateCopilotResponse" as const,
  input: z.object({ conversationId: z.string(), prevMessageId: z.string() }),
  output: z.object({ text: z.string() }),
};
